import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = {
  key: 0,
  id: "pwa-install-prompt",
  class: "pwa-install-prompt"
}
const _hoisted_3 = { class: "pwa-prompt-content" }
const _hoisted_4 = { class: "pwa-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimeToast = _resolveComponent("PrimeToast")!
  const _component_PrimeConfirmDialog = _resolveComponent("PrimeConfirmDialog")!
  const _component_OfflineStatusNotification = _resolveComponent("OfflineStatusNotification")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PrimeToast, { position: "top-right" }),
    _createVNode(_component_PrimeConfirmDialog),
    _createVNode(_component_OfflineStatusNotification),
    (_ctx.showInstallPrompt)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('pwa.title')), 1),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.installPWA && _ctx.installPWA(...args))),
                class: "install-button"
              }, _toDisplayString(_ctx.$t('pwa.install')), 1),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.dismissInstallPrompt && _ctx.dismissInstallPrompt(...args))),
                class: "dismiss-button"
              }, _toDisplayString(_ctx.$t('pwa.later')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component }) => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
      ]),
      _: 1
    })
  ]))
}